/*
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-09-26 14:05:04
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-28 17:12:33
 * @FilePath: \ces-vue-serve\src\API\request\service.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import { GetAuthToken } from 'rj-server-auth-token';
import { jumpShutDownPage } from '@/libs/util';
// import { Notification } from 'element-ui';
import { getSign } from '../requestEncryption';
import Cookies from 'js-cookies';

const seriveFactory = function (opt, errCallBack) {
  let API = axios.create(opt);

  API.interceptors.request.use(
    config => {
      config.headers['web-sign-server-auth'] = GetAuthToken({
        sysId: 'c0c73417cf58cb87e146a78f6e44ef44',
        accessKeySecret: '7B3A866D-7343-540C-30FD-0E71BE1B667B'
      });
      config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
      config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

      let timestamp = localStorage.getItem('timestamp');
      if (timestamp && timestamp + 600000 > new Date().getTime()) {
        timestamp = new Date().getTime();
        localStorage.setItem('timestamp', timestamp);
      } else {
        timestamp = new Date().getTime();
      }
      const sign = getSign(config, axios, timestamp);
      config.headers['sign'] = sign;
      config.headers['timestamp'] = timestamp;

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // http响应拦截器
  API.interceptors.response.use(
    res => {
      let json = res.data;
      // 后台返回blob类型，不验证自定义的状态码，一般用于文件流下载
      // if (res.config && res.config.responseType === 'blob') {
      //   return res;
      // }
      // 停机维护
      if (res.data.status === '503') {
        jumpShutDownPage(res.data.data);
      }
      if (json && json.status !== '200') {
        toString.call(errCallBack) === '[object Function]' && errCallBack(json);
      }
      return res.data;
    },
    error => {
      if (error.message.includes('428')) {
        Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
        Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
        Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
        Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
        Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
        // 干掉切换的渠道
        Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
        window.localStorage.removeItem('union_session_ticket');
        if (window._env_.NODE_ENV !== 'pro') {
          window.location.href = `${window.location.origin}/toLoginPage`;
        } else {
          window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
        }
        // return Notification.warning({
        //   message: '登录验证失败或登录已失效，请重新登录'
        // });
      }
      toString.call(errCallBack) === '[object Function]' && errCallBack({}, error);
      return Promise.reject(error);
    }
  );
  return API;
};
export default seriveFactory;
